import React, { useState, useEffect } from 'react';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import TextField from '@material-ui/core/TextField';
import styles from './ACClue.module.scss';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';

const ACChallange = ({ isChecked, onCheckChanged, challangeValue, onChallangeValueChanged, style }) => {
  const [error, setError] = useState(undefined);

  const checkChallangeValidity = (challangeName) => {
    const regex = /^[A-Za-z0-9\s-'+&ÅåÄäÖöÆæØø]+$/;
    const isValid = regex.test(challangeName);
    if (!isValid || isEmpty(challangeName)) {
      setError(
        `A solution cannot be empty. Capitalisation is excluded from validation. Allowed characters are: A-Z, numbers and symbols ' - + &`
      );
      return false;
    } else {
      setError(undefined);
      return true;
    }
  };

  useEffect(() => {
    checkChallangeValidity(challangeValue);
  }, [challangeValue]);
  return (
    <div style={style}>
      <FormControlLabel
        control={<Checkbox color="primary" checked={isChecked} onChange={onCheckChanged} />}
        label={'Solvable'}
        key={'solvable'}
      />
      {isChecked && (
        <>
          <TextField
            value={challangeValue}
            onChange={onChallangeValueChanged}
            className={styles.textField}
            error={!!error}
          />
          {<p className={styles.error}>{error}</p>}
        </>
      )}
    </div>
  );
};

ACChallange.propTypes = {
  isChecked: PropTypes.bool,
  onCheckChanged: PropTypes.func.isRequired,
  challangeValue: PropTypes.string,
  onChallangeValueChanged: PropTypes.func.isRequired,
  style: PropTypes.objectOf(PropTypes.string),
};

ACChallange.defaultProps = {
  isChecked: false,
  challangeValue: '',
  style: {},
};

export default ACChallange;
